import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {useFormik} from "formik";
import moment from "moment/moment";
import * as Yup from "yup";
import {Container, Row, Col} from "react-bootstrap";
import Target from "../../../ui/components/Target/Target";
import cl from './AlertForm.module.css';
import Input from "../../../ui/components/Input/Input";



const AlertForm = ({
                      id,
                      createdOn,
                      text,
                      name,
                       noSms,
                      targets,
                      onSubmit
                  }) => {

    const {t} = useTranslation();

    const form = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: id,
            createdOn: createdOn !== null ? moment.utc(createdOn).toDate() : null,
            text: text,
            name: name,
            noSms: noSms,
            targets: targets
        },
        validationSchema: Yup.object({
            name: Yup.string()
                .required(t("errors.required-error").replace('{0}', t("Alert.form.category"))),
        }),
        onSubmit: onSubmit
    });

    return (
        <Container fluid>
            <form id='page-form' onSubmit={form.handleSubmit}>
                {/*<Row>
                    <Col>
                        <div className='input-container syncfusion-control-input-container'>
                            <label className='label required'>
                                {t("alert.form.name")}
                            </label>
                            <Input name='name'
                                   type='text'
                                   placeholder={t("alert.form.name")}
                                   disabled={true}
                                   onChange={form.handleChange}
                                   autoComplete='off'
                                   value={form.values.name}/>
                        </div>
                    </Col>

                </Row>*/}
                <Row className={cl.formRow}>
                    <Col>
                        <div className='input-container syncfusion-control-input-container'>
                            <label className='label required'>
                                {t("alert.form.text")}
                            </label>
                            <Input name='text'
                                   type='text'
                                   placeholder={t("alert.form.text")}
                                   disabled={form.isSubmitting}
                                   onChange={form.handleChange}
                                   autoComplete='off'
                                   value={form.values.text}/>
                        </div>
                    </Col>

                </Row>
                <Row>
                    <Col>
                    </Col>
                    <Col className={cl.checkboxesContainer}>
                        <div className='input-container checkbox'>
                            <label className='label'>
                                {t("alert.form.noSms")}
                            </label>
                            <Input name='noSms'
                                   type='checkbox'
                                   disabled={form.isSubmitting}
                                   onChange={form.handleChange}
                                   checked={form.values.noSms}/>
                        </div>

                    </Col>
                </Row>

            </form>
            <Row className={cl.formRow}>

                <Col>
                    <Target targets={form.values.targets}
                            disabled={form.isSubmitting}
                            change={(items) => form.setFieldValue('targets', items)}/>
                </Col>
            </Row>


        </Container>
    );
};

export default AlertForm;
